import React from 'react';
import { WithStylesProps } from 'react-jss';

import { EM_DASH } from '~/common/constants/unicode';
import EcSelect from '~/components/Shared/EcSelect/EcSelect';

import { booleanOptions } from '../../../DocumentOverviewPanel/helpers';
import styles from '../InformationField.styles';
import { Field } from '../InformationFieldV2';

interface BooleanFieldProps extends WithStylesProps<typeof styles> {
  field: Field;
  editMode: boolean;
  fieldValue: any;
  setFieldValue: (value: any) => void;
}

export const BooleanField = ({
  classes,
  field,
  editMode,
  fieldValue,
  setFieldValue,
}: BooleanFieldProps) => {
  if (editMode) {
    const presentValue = fieldValue
      ? { label: fieldValue.display_value, value: fieldValue.value }
      : null;

    return (
      <div className={classes.editItemContainer}>
        <EcSelect
          aria-label={field.name}
          defaultValue={presentValue}
          options={booleanOptions}
          onChange={(newValue: any) =>
            setFieldValue({
              display_value: newValue.label,
              value: newValue.value,
            })
          }
          isDisabled={!field.is_editable}
          isSearchable={false}
        />
      </div>
    );
  }

  return fieldValue ? fieldValue.display_value : EM_DASH;
};
